export default __webpack_public_path__ + "static/media/Advanced Potion Making - Final_08.dd06f274.jpg";